const displayName = 'User'

export default displayName